export var config = {
  entryName: 'entry'
};

export var entryMappers = {
  createToEntry: function createToEntry(data) {
    return data.content || {};
  },
  updateToEntry: function updateToEntry(data) {
    return data[config.entryName] || {};
  },
  deleteToEntry: function deleteToEntry(data) {
    return data[config.entryName] || {};
  }
};

export var awsDataToEntry = function awsDataToEntry(tag) {
  return function (data) {
    return data[tag];
  };
};

export var sdcDataToEntry = function sdcDataToEntry(tag) {
  return function (data) {
    return data[tag];
  };
};